package com.rainbowclubs.rainbow.presentation.admin

import androidx.lifecycle.ViewModel
import com.rainbowclubs.rainbow.data.models.UserRole
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.*

class ManageMembersViewModel(
    private val clubId: String,
    role: UserRole,
) : ViewModel() {

    sealed class NavigationEvent {
        object Back : NavigationEvent()
        data class NewInvitations(val clubId: String) : NavigationEvent()
        data class ExistingMembers(val clubId: String) : NavigationEvent()
    }

    private val _uiState = MutableStateFlow(ManageMembersUiState(role = role))
    val uiState: StateFlow<ManageMembersUiState> = _uiState.asStateFlow()

    private val navigationIntentChannel = Channel<NavigationEvent>(Channel.BUFFERED)
    val navigationIntent: Flow<NavigationEvent> = navigationIntentChannel.receiveAsFlow()

    fun onBackClick() {
        navigationIntentChannel.trySend(NavigationEvent.Back)
    }

    fun onNewInvitationsClick() {
        navigationIntentChannel.trySend(NavigationEvent.NewInvitations(clubId))
    }

    fun onExistingMembersClick() {
        if (_uiState.value.role == UserRole.SUPER_ADMIN) {
            navigationIntentChannel.trySend(NavigationEvent.ExistingMembers(clubId))
        }
    }
}

data class ManageMembersUiState(
    val role: UserRole,
)
